import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminEmailsService } from 'src/app/shared/api/admin-emails.service';
import { IFilterComponentConfiguration } from 'src/app/shared/components/filter-component/filter-component.component';
import { TableListComponent } from 'src/app/shared/components/table-list/table-list.component';
import { ActionsTabela } from 'src/app/shared/components/tabela-listagem/tabela-listagem.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NotificationService } from 'src/app/shared/services/notificationService';
import { ColumnDataType } from 'src/app/shared/model/resource';
import { TemplateApiService } from 'src/app/shared/api/template-api.service';
import { IResponse } from 'src/app/shared/api/response.model';
import { adminEmailsResource } from './admin-emails.resource';

@Component({
    selector: 'app-admin-emails',
    templateUrl: './admin-emails.component.html',
    styleUrls: ['./admin-emails.component.scss']
})
export class AdminEmailsComponent implements OnInit {
    @ViewChild('listagemEmails') listagemEmails!: TableListComponent;

    emailsResource = adminEmailsResource;
    filterConfiguration!: IFilterComponentConfiguration;
    actions: ActionsTabela[] = [];

    carregando = false;

    constructor(
        public adminEmailsService: AdminEmailsService,
        private dialog: DialogService,
        private notify: NotificationService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.configureFilters();
        this.configureActions();
    }

    private configureActions() {
        this.actions = [
            {
                hint: 'Reenviar e-mail',
                icon: 'send',
                text: 'Reenviar',
                type: 'accent',
                mode: 'single',
                onClick: (entity: any) => {
                    this.reenviarEmail(entity);
                }
            }
        ];
    }

    reenviarEmail(entity: any) {
        this.dialog.confirm(
            'Confirmar reenvio',
            `Deseja reenviar o e-mail para ${entity.destinatario}?`
        ).subscribe((confirm: boolean) => {
            if (confirm) {
                this.carregando = true;
                this.adminEmailsService.reenviar(entity.uuid).subscribe({
                    next: () => {
                        this.carregando = false;
                        this.notify.success('E-mail reenviado com sucesso!');
                        this.listagemEmails?.tabela?.listarEntidades();
                    },
                    error: (e) => {
                        this.carregando = false;
                        this.notify.error(e.error.erro);
                    }
                });
            }
        });
    }

    private configureFilters() {
        this.filterConfiguration = {
            colunas: [
                {
                    field: 'destinatario',
                    label: 'Destinatário',
                    type: ColumnDataType.Text,
                    sizeColumn: 'col-xl-4'
                }
            ],
            tratarValoresFiltrar: ($event: any) => {
                const filtro: any = {};
                if (!$event) return filtro;
                if ($event.destinatario) filtro['destinatario'] = $event.destinatario;
                return filtro;
            }
        };
    }
}
